import { Link, Outlet } from "react-router-dom";
import A11yToolbar from "./A11yToolbar";
import Header from "./Header";
import Footer from "./Footer";
import { LocalBusinessSchema } from "./Seo";

export default function Layout() {
  return (
    <div className="min-h-screen pb-24 md:pb-0">
      <a href="#main-content" className="sr-only z-50 rounded-xl bg-amber px-5 py-3 font-semibold text-on-amber focus:not-sr-only focus:fixed focus:left-4 focus:top-4" data-testid="skip-link">
        Skip to main content
      </a>
      <A11yToolbar />
      <Header />
      <main id="main-content" tabIndex={-1} className="focus:outline-none">
        <Outlet />
      </main>
      <Footer />
      <LocalBusinessSchema />
      <div className="fixed inset-x-0 bottom-0 z-40 flex gap-2 border-t border-line bg-surface/95 p-3 shadow-2xl backdrop-blur-md md:hidden" role="region" aria-label="Quick actions" data-testid="mobile-sticky-cta">
        <Link to="/request-trial" className="btn-primary flex-1 !px-3" data-testid="sticky-trial-btn">Request a Trial</Link>
        <Link to="/referrers#referral-form" className="btn-accent flex-1 !px-3" data-testid="sticky-referral-btn">Make a Referral</Link>
      </div>
    </div>
  );
}
